import { useContext } from "react";
import * as XLSX from "xlsx";

import { toDateTime } from "Helpers/Format";

import Button from "Components/Admin/Buttons";

import { TableContext } from "../..";

import { get } from "lodash";

const Download = ({ name, downloadColumns, disabled }) => {
  const { rows } = useContext(TableContext);

  const exportToExcel = () => {
    const data = rows.map((row) => {
      const formattedRow = row.original;
      if (row) {
        Object.keys(formattedRow).forEach((key) => {
          if (formattedRow[key] === null) {
            formattedRow[key] = "N/A";
          }
        });
      }
      return formattedRow;
    });

    const formattedData = data.map((row) => {
      const formattedRow = {};
      downloadColumns.forEach((column) => {
        formattedRow[column.Header] =
          typeof column.accessor === "string"
            ? get(row, column.accessor)
            : column.accessor(row);
      });
      return formattedRow;
    });

    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, `${name} ${toDateTime(new Date())}.xlsx`);
  };

  return (
    <Button
      type="button"
      text="Baixar"
      onClick={exportToExcel}
      disabled={disabled}
    ></Button>
  );
};

export default Download;
